import { gql } from "graphql-tag";

export const customerReviewV2 = gql`
  fragment Home_page_v2_customer_review_v2 on Home_page_v2SlicesCustomer_review_v2 {
    type
    variation {
      ... on Home_page_v2SlicesCustomer_review_v2Default {
        primary {
          subtitle
        }
      }
    }
  }
`;
